/* eslint-disable react-hooks/exhaustive-deps */
import { AutocompleteChangeReason, SxProps, Theme } from '@mui/material';
import { useEffect, useState } from 'react';
import { IconButton, TextField } from 'src/components';
import Autocomplete from 'src/components/Autocomplete';
import ModulEnum from 'src/enums/ModulEnum';
import { IParametersKeyValue } from "src/store/Slices/Base/ParametersSlice";
import { isVisible } from 'src/utils/formAuthHelper';
import { helper } from 'src/utils/helper';
import { getParametrePartsFind } from "src/utils/ParametreHelper";
import { AutoCompleteTargetNumber } from '../Types/autocomplete.target';
import GnlParametreProps from './gnl.parametre.props';
import { useCrateKullaniciVarsayilanMutation, useGetKullaniciVarsayilanListQuery, useUpdateKullaniciVarsayilanMutation } from 'src/services/Base/GnlKullaniciVarsayilanApi';
import { useAppSelector } from 'src/store';
import { useConfirmation } from 'src/base/ConfirmationDialog/ConfirmationService';
import { translate } from 'src/i18n/tHelper';
import GnlKullanicivarsayilanDTO from 'src/models/Genel/GnlKullanicivarsayilanDTO';

interface GnlParametreSelectProps extends GnlParametreProps {
  value?: number;
  disableClearable?: boolean;
  sx?: SxProps<Theme>;
  name?: string;
  label?: string;
  error?: boolean;
  children?: React.ReactNode;
  id?: string;
  required?: boolean;
  onChange?: (e: AutoCompleteTargetNumber, value: IParametersKeyValue, reason: AutocompleteChangeReason) => void;
  onBlur?: (e: AutoCompleteTargetNumber) => void;
  authCode?: string;
  modul?: ModulEnum;
  disabled?: boolean;
  placeHolder?: string;
  readOnly?: boolean;
  borderNone?: boolean;
  filterCode?: Array<number>;
  kullaniciVarsayilanAktif?: boolean;
  varsayilanKontrolAd?: string;
  onBlurAktifEt?: boolean;
  hepsiDahil?: boolean;
}
const translatePath = "parts|parametre";
const GnlParametreSelect = (props: GnlParametreSelectProps): JSX.Element => {
  const userInfo = useAppSelector(s => s.userLogin.userInfo);
  const [options, setOptions] = useState(new Array<IParametersKeyValue>());
  const [value, setValue] = useState<IParametersKeyValue>({});
  const confirm = useConfirmation();

  const kullaniciVarsayilanQuery = useGetKullaniciVarsayilanListQuery(userInfo.id);
  const [kullaniciVarsayilanEkle, kullaniciVarsayilanEkleState] = useCrateKullaniciVarsayilanMutation();
  const [kullaniciVarsayilanGuncelle, kullaniciVarsayilanGuncelleState] = useUpdateKullaniciVarsayilanMutation();
  const kayit = kullaniciVarsayilanQuery?.data?.find((m) => m?.ekranAd === "PARAMETRE_AUTOCOMPLETE" && m?.kontrolad === props.varsayilanKontrolAd);


  useEffect(() => {
    const parameterState = getParametrePartsFind(props.sortById, props.parametreType, props.pasifDahil);
    if (props.filterCode?.length > 0)
      if (props.hepsiDahil)
        setOptions([
          { id: 0, key: 0, value: translate(translatePath, "Hepsi"), siraNo: 0, grupId: props.parametreType, aktif: "E", alan01: "", trValue: translate(translatePath, "Hepsi") },
          ...parameterState.filter(f => props.filterCode.includes(f.key))
        ]);
      else
        setOptions(parameterState.filter(f => props.filterCode.includes(f.key)));
    else
      if (props.hepsiDahil)
        setOptions([
          { id: 0, key: 0, value: translate(translatePath, "Hepsi"), siraNo: 0, grupId: props.parametreType, aktif: "E", alan01: "", trValue: translate(translatePath, "Hepsi") },
          ...parameterState
        ])
      else
        setOptions(parameterState)
  }, [props.parametreType, props.pasifDahil, props.sortById])

  useEffect(() => {
    if (options?.length > 0) {
      if (!kullaniciVarsayilanQuery.isFetching && kullaniciVarsayilanQuery.data?.length > 0 && options?.length > 0) {
        let bul = kullaniciVarsayilanQuery.data?.find((m) => m.ekranAd === "PARAMETRE_AUTOCOMPLETE" && m.kontrolad === props.varsayilanKontrolAd);
        if (bul?.id > 0) {
          setValue(options?.find((f) => f.key === helper.objectToNumber(bul?.deger)));
          props.onChange({ target: { value: helper.objectToNumber(bul?.deger), name: props.name } }, options?.find((f) => f.id === helper.objectToNumber(bul?.deger)), null);
          return;
        }
      }
    }
  }, [kullaniciVarsayilanQuery.isFetching, options]);

  useEffect(() => {
    setValue(options?.find((f) => f.key == props.value && f.grupId === props.parametreType));
  }, [options, props.parametreType, props.value]);

  const favoriYapHandler = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, row: number) => {
    if (!kullaniciVarsayilanQuery.isFetching && !kullaniciVarsayilanEkleState.isLoading && !kullaniciVarsayilanGuncelleState.isLoading) {
      if (kayit?.id > 0) {
        confirm({
          description: translate(translatePath, "Varsayılan kaydınız güncellenecektir, Emin misiniz?"),
          title: translate(translatePath, "Bilgi"),
          variant: "danger"
        }).then(async () => {
          await kullaniciVarsayilanGuncelle({ ...kayit, deger: helper.objectToString(row) }).unwrap().then(() => { }).catch(e => e);
          return;
        })
        return;
      }
      else {
        confirm({
          description: translate(translatePath, "Varsayılan kaydınız olarak eklenecek, Emin misiniz?"),
          title: translate(translatePath, "Bilgi"),
          variant: "danger"
        }).then(async () => {
          let veri: GnlKullanicivarsayilanDTO = {
            ...new GnlKullanicivarsayilanDTO(),
            ekranAd: "PARAMETRE_AUTOCOMPLETE",
            kontrolad: props.varsayilanKontrolAd,
            deger: helper.objectToString(row),
            fkGnlKullanici: userInfo.id,
          };
          await kullaniciVarsayilanEkle(veri).unwrap().then(() => { }).catch(e => e);
        });
      }
    }
  };

  return (
    isVisible(props.authCode, props.modul) && (
      <Autocomplete
        readOnly={props.readOnly}
        disabled={props.disabled}
        fullWidth
        freeSolo={false}
        multiple={false}
        sx={props.sx}
        id={props.id}
        disableClearable={props.disableClearable ? props.disableClearable : props.required}
        value={typeof value?.key === "number" ? value : null}
        options={options}
        isOptionEqualToValue={(o, s) => o?.key == s?.key}
        filterOptions={(option, state) => {
          return option?.filter(
            (f) =>
              helper
                .UpperCaseAsc(f.value)
                .indexOf(helper.UpperCaseAsc(state.inputValue)) > -1
          );
        }}
        getOptionLabel={(option) => option?.value?.toString() ?? ''}
        renderOption={(props, option) => (
          <li {...props} key={option.key}>
            {option.value}
          </li>
        )}
        onBlur={(e) => {
          if (props.onBlurAktifEt) {
            if (props.onBlur)
              props.onBlur({ ...e, target: { value: value?.key, name: props.name } });
            return;
          } else {
            if (props.onChange)
              props.onChange(
                { target: { value: value?.key, name: props.name } },
                value, null
              );
          }
        }}
        onChange={(e, v, r, d) => {
          setValue(v);
          if (props.onChange)
            props.onChange({ target: { value: v?.key, name: props.name } }, v, r);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            borderNone={props.borderNone}
            sx={props.sx}
            label={props.label}
            required={props.required}
            error={props.error}
            helperText={props.helperText}
            placeholder={props.placeHolder}
            InputProps={{
              ...params.InputProps,
              endAdornment: value?.key > 0 ? (
                <>
                  {params.InputProps.endAdornment}
                  {props.kullaniciVarsayilanAktif && (
                    <>
                      {helper.objectToNumber(kayit?.deger) > 0 ? (
                        <IconButton
                          customType="star"
                          toolTip={translate(translatePath, "Varsayılan Güncelle")}
                          loading={helper.objectToNumber(kullaniciVarsayilanEkleState.originalArgs?.deger) === value?.key ? kullaniciVarsayilanEkleState.isLoading : helper.objectToNumber(kullaniciVarsayilanGuncelleState.originalArgs?.deger) === value?.key && kullaniciVarsayilanGuncelleState.isLoading}
                          onClick={(e) => { favoriYapHandler(e, value?.key); }}
                          sx={{ padding: 0 }}
                        />
                      ) : (
                        <IconButton
                          customType="unstar"
                          toolTip={translate(translatePath, "Varsayılan Ata")}
                          loading={helper.objectToNumber(kullaniciVarsayilanEkleState.originalArgs?.deger) === value?.key ? kullaniciVarsayilanEkleState.isLoading : helper.objectToNumber(kullaniciVarsayilanGuncelleState.originalArgs?.deger) === value?.key && kullaniciVarsayilanGuncelleState.isLoading}
                          onClick={(e) => { favoriYapHandler(e, value?.key); }}
                          sx={{ padding: 0 }}
                        />
                      )}
                    </>
                  )}
                </>
              ) : params.InputProps?.endAdornment
            }}
          />
        )}
      />
    ));
};
export default GnlParametreSelect;
